import React, { lazy, Suspense } from 'react'
import { Route, Redirect, Switch, BrowserRouter } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { connect } from 'react-redux'
import NavigatorGlobalScreens from 'components/platform/NavigatorGlobalScreens'
import Layout from 'layouts'
import { hot } from 'react-hot-loader'
import CustomerContractModal from "./components/CustomerContractModal";
import {PrivacyManagementModal} from './pages/platform/CurriculumPage/AreaCandidate/PrivacyManagementModal'

const routes = [
  // Home
  {
    path: '/home',
    Component: lazy(() => import('pages/home')),
    exact: true,
  },

  // PLatform
  {
    path: '/curriculum_base',
    Component: lazy(() => import('pages/hrm/CandidatesPage')),
    exact: true,
  },
  {
    path: '/candidates/:itemId?/:pageDashboard?',
    Component: lazy(() => import('pages/platform/CurriculumPage')),
    exact: true,
  },
  {
    path: '/candidates-interview/:itemId?',
    Component: lazy(() => import('pages/platform/InterviewsPage')),
    exact: true,
  },
  {
    path: '/external/candidate/:itemId?',
    Component: lazy(() => import('pages/platform/CurriculumPage/ExternalLink')),
    exact: true,
  },
  {
    path: '/external/customer_candidate/:itemId?',
    Component: lazy(() => import('pages/platform/CurriculumPage/ExternalLink')),
    exact: true,
  },
  {
    path: '/calendar',
    Component: lazy(() => import('pages/platform/CalendarsPage')),
    exact: true,
  },
  {
    path: '/graphics',
    Component: lazy(() => import('pages/platform/GraphicsPage/GraphicsAnalysis')),
    exact: true,
  },
  {
    path: '/candidate-analysis',
    Component: lazy(() => import('pages/platform/GraphicsPage/CandidateAnalysis')),
    exact: true,
  },
  {
    path: '/channels-analysis',
    Component: lazy(() => import('pages/platform/GraphicsPage/ChannelsAnalysis')),
    exact: true,
  },
  {
    path: '/projects-analysis',
    Component: lazy(() => import('pages/platform/GraphicsPage/ProjectsAnalysis')),
    exact: true,
  },
  {
    path: '/candidature-analysis',
    Component: lazy(() => import('pages/platform/GraphicsPage/CandidatureAnalysis')),
    exact: true,
  },
  {
    path: '/calendarTable',
    Component: lazy(() => import('pages/platform/CalendarsPage/CalendarsTable')),
    exact: true,
  },
  {
    path: '/users/:itemId?',
    Component: lazy(() => import('pages/platform/UsersPage')),
    exact: false,
  },
  {
    path: '/groups/:itemId?',
    Component: lazy(() => import('pages/platform/GroupsPage')),
    exact: true,
  },
  {
    path: '/tenants/:itemId?',
    Component: lazy(() => import('pages/platform/TenantsPage')),
    exact: true,
  },
  {
    path: '/translate',
    Component: lazy(() => import('pages/platform/TranslatePage')),
    exact: true,
  },
  {
    path: '/customers/:itemId?',
    Component: lazy(() => import('pages/platform/CustomersPage')),
    exact: true,
  },
  {
    path: '/courses/:itemId?',
    Component: lazy(() => import('pages/platform/CoursesCertificationPage')),
    exact: true,
  },
  {
    path: '/job-ads/',
    Component: lazy(() => import('pages/platform/CoursesCertificationPage')),
    exact: true,
  },
  {
    path: '/surveys',
    Component: lazy(() => import('pages/platform/SurveysPage')),
    exact: true,
  },
  {
    path: '/projects/:itemId?',
    Component: lazy(() => import('pages/platform/ProjectsPage')),
    exact: true,
  },
  {
    path: '/seller-projects/:itemId?',
    Component: lazy(() => import('pages/platform/ProjectsPage/SellersProjects')),
    exact: true,
  },
  {
    path: '/customer/candidate/:itemId?',
    Component: lazy(() => import('pages/platform/CurriculumPage/ExternalLink/ProjectCandidateDataroom')),
    exact: true,
  },
  {
    path: '/projects-history/:itemId?',
    Component: lazy(() => import('pages/platform/ProjectsLogPage')),
    exact: true,
  },
  {
    path: '/email-template/:itemId?',
    Component: lazy(() => import('pages/platform/EmailTemplatePage')),
    exact: true,
  },
  {
    path: '/email-sent/:itemId?',
    Component: lazy(() => import('pages/platform/EmailOutboxPage')),
    exact: true,
  },
  {
    path: '/documents-template/:itemId?',
    Component: lazy(() => import('pages/platform/DocumentsTemplatePage')),
    exact: true,
  },
  {
    path: '/item-codes/:itemId?',
    Component: lazy(() => import('pages/platform/ItemCodesPage/index')),
    exact: true,
  },
  {
    path: '/pipeline/:itemId?',
    Component: lazy(() => import('pages/platform/PipelinePage/index')),
    exact: true,
  },
  {
    path: '/skills/:itemId?',
    Component: lazy(() => import('pages/platform/SkillsPage')),
    exact: true,
  },
  {
    path: '/backups/:itemId?',
    Component: lazy(() => import('pages/platform/BackupsPage')),
    exact: true,
  },
  {
    path: '/tenant-management',
    Component: lazy(() => import('pages/platform/TenantManagementPage')),
    exact: true,
  },
  {
    path: '/settings',
    Component: lazy(() => import('pages/platform/SettingsPage')),
    exact: true,
  },
  {
    path: '/profile/:itemId?',
    Component: lazy(() => import('pages/platform/ProfilePage')),
    exact: true,
  },
  // Auth Pages
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
  },
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },
  // Dev

  // Dev
  {
    path: '/components',
    Component: lazy(() => import('pages/dev/ComponentsPage')),
    exact: true,
  },
  {
    path: '/dev',
    Component: lazy(() => import('pages/dev/DevPage')),
    exact: true,
  },
]

const meRoutes = [
  {
    path: '/resume/:section',
    Component: lazy(() => import('pages/platform/CurriculumPage/AreaCandidate')),
    exact: true,
  },
  {
    path: '/jobads/',
    Component: lazy(() => import('pages/platform/CurriculumPage/AreaCandidate')),
    exact: true,
  },
  {
    path: '/jobad/:itemId',
    Component: lazy(() => import('pages/platform/CurriculumPage/AreaCandidate')),
    exact: true,
  },
]

const customerRoutes = [
  {
    path: '/projects/:itemId?',
    Component: lazy(() => import('pages/platform/DataroomArea')),
    exact: true,
  },
  {
    path: '/projects/candidate/:itemId?',
    Component: lazy(() => import('pages/platform/CurriculumPage/ExternalLink/ProjectCandidateDataroom')),
    exact: true,
  }
]

const isDataroomCandidate = () => {
  return (
    window.location.pathname.includes('customer/')
    && window.location.hash.includes('/projects/candidate/')
  ) ||  window.location.hash.includes('/customer/candidate/')
}

const Router = ({ history, routerAnimation }) => {

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          <ConnectedRouter history={history}>
            <Layout type={isDataroomCandidate() ? 'externalLink' : undefined}>
              <Switch>
                <Route exact path="/" render={() => <Redirect to="/home" />} />
                {routes.map(({ path, Component, exact }) => (
                  <Route
                    path={path}
                    key={path}
                    exact={exact}
                    render={props => {
                      return (
                        <div className={routerAnimation}>
                          <Suspense fallback={null}>
                            <Component {...props} />
                          </Suspense>
                        </div>
                      )
                    }}
                  />
                ))}
                <Redirect to="/auth/404" />
              </Switch>
              <NavigatorGlobalScreens />
            </Layout>
          </ConnectedRouter>
        </Route>

        <Route exact path="/me">
          <ConnectedRouter history={history}>
            <Layout type={'clear'} areaId={3}>
              <PrivacyManagementModal />
              <Switch>
                <Route exact path="/" render={() => <Redirect to="/resume/profile" />} />
                {meRoutes.map(({ path, Component, exact }) => (
                  <Route
                    path={path}
                    key={path}
                    exact={exact}
                    render={props => {
                      return (
                        <Suspense fallback={null}>
                          <Component {...props} />
                        </Suspense>
                      )
                    }}
                  />
                ))}
              </Switch>
              <NavigatorGlobalScreens />
            </Layout>
          </ConnectedRouter>
        </Route>

        <Route exact path="/customer">
          <ConnectedRouter history={history}>
            <Layout type={isDataroomCandidate() ? 'externalLink' : 'clear'} areaId={2}>
              <CustomerContractModal />
              <Switch>
                <Route exact path="/" render={() => <Redirect to="/projects" />} />
                {customerRoutes.map(({ path, Component, exact }) => (
                  <Route
                    path={path}
                    key={path}
                    exact={exact}
                    render={props => {
                      return (
                        <Suspense fallback={null}>
                          <Component {...props} />
                        </Suspense>
                      )
                    }}
                  />
                ))}
              </Switch>
              <NavigatorGlobalScreens />
            </Layout>
          </ConnectedRouter>
        </Route>
      </Switch>
    </BrowserRouter>
  )
}

export default process.env.NODE_ENV === 'development'
  ? connect()(hot(module)(Router))
  : connect()(Router)
